
import { useState } from 'react';

export default function Footer() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('nome', formData.nome);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('mensagem', formData.mensagem);

      const response = await fetch('https://readdy.ai/api/form/d3ddo010o0a6mrted33g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', mensagem: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/32da3dbc6c077a42865d0d012e77efdf/a928ae752c1ca469c6e93cbddf564096.png" 
                alt="ZENAS" 
                className="h-20 w-20 object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Especialistas em kits de facas profissionais para transformar sua experiência culinária.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato e Suporte</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-red-400"></i>
                <span>(84) 99949-5676</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-green-400"></i>
                <span>(84) 99949-5676</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-blue-400"></i>
                <span>sac@lojazenas.com.br</span>
              </div>
              <div className="text-sm text-gray-400 mt-4">
                <p><strong>Horário de Atendimento:</strong></p>
                <p>Segunda a Sexta: 8h às 18h</p>
                <p>Sábado: 8h às 12h</p>
              </div>
            </div>
          </div>
          
          <div id="contato">
            <h4 className="text-lg font-semibold mb-4">Fale Conosco</h4>
            <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
              <input
                type="text"
                name="nome"
                placeholder="Seu nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:border-red-400 text-sm"
              />
              <input
                type="email"
                name="email"
                placeholder="Seu email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:border-red-400 text-sm"
              />
              <textarea
                name="mensagem"
                placeholder="Sua mensagem"
                value={formData.mensagem}
                onChange={handleInputChange}
                required
                maxLength={500}
                rows={3}
                className="w-full px-4 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:border-red-400 text-sm resize-none"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
              
              {submitStatus === 'success' && (
                <p className="text-green-400 text-sm">Mensagem enviada com sucesso!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-sm">Erro ao enviar mensagem. Tente novamente.</p>
              )}
            </form>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 Kit Facas Profissional. Todos os direitos reservados.</p>
          <div className="mt-2">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-300"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
